import { useMemo } from 'react'
import { useLocation } from '@reach/router'
import qs from 'qs'

export default () => {
  const { search } = useLocation()
  return useMemo(() => qs.parse(search.substring(1)), [search])
}
